export default __webpack_public_path__ + "static/media/a037-student-t3-10.d569e05a.svg";